module.exports = __webpack_public_path__ + "img/newlogo_wide@2x.d66a4ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/newlogo_wide@2x.png
// module id = AJY6
// module chunks = 71